module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ja-地图.d16fa593.png";